"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var WalletInterface = require('../interface/walletInterface');

var Provider = require('../provider');

var Privatekey = require('./privatekey');

var Mnemonic = require('./mnemonic');

var Keystore = require('./keystore');

var Isoxys = /*#__PURE__*/function (_WalletInterface) {
  _inherits(Isoxys, _WalletInterface);

  var _super = _createSuper(Isoxys);

  /**
   * Constructor
   * @param {*} net 
   * @param {*} options - extra options for specific wallets
   * getPassphrase
   * getApproval
   */
  function Isoxys(net, options) {
    var _this;

    _classCallCheck(this, Isoxys);

    _this = _super.call(this, net, 'softwallet');

    _defineProperty(_assertThisInitialized(_this), "setWallet", function (accOpts, callback) {
      _this.provider = new Provider.SoftWallet(_this.net);
      accOpts.getPassphrase = _this.getPassphrase;
      accOpts.approveTransaction = _this.getApproval;
      return _this.provider.init(accOpts, function (er, web3) {
        if (er) return callback(er, null);
        _this.web3 = web3;
        return callback(null, web3);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setAccountByPrivatekey", function (privateKey, callback) {
      console.warn("ATTENTION:\n    This function is using private key in direct.\n    Eventhought it was secured by some cryptographical functions,\n    but we highly recommend to avoid using it in the production environment.");
      var account = Privatekey.privatekeyToAccount(privateKey);
      if (!account) return callback('Invalid private key', null);
      return _this.setWallet(account, callback);
    });

    _defineProperty(_assertThisInitialized(_this), "getAccountByPrivatekey", function (privateKey, callback) {
      console.warn("ATTENTION:\n    This function is using private key in direct.\n    Eventhought it was secured by some cryptographical functions,\n    but we highly recommend to avoid using it in the production environment.");
      var account = Privatekey.privatekeyToAccount(privateKey);
      if (!account) return callback('Invalid private key', null);
      return callback(null, account.address);
    });

    _defineProperty(_assertThisInitialized(_this), "setAccountByMnemonic", function (mnemonic, password, path, index, callback) {
      return Mnemonic.mnemonicToSeed(mnemonic, password, function (seed) {
        var hdk = Mnemonic.seedToHDKey(seed);
        var account = Mnemonic.hdkeyToAccount(hdk, path, index);
        if (!account) return callback('Cannot derive account from mnemonic', null);
        return _this.setWallet(account, callback);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getAccountsByMnemonic", function (mnemonic, password, path, limit, page, callback) {
      return Mnemonic.mnemonicToSeed(mnemonic, password, function (seed) {
        var list = [];
        var hdk = Mnemonic.seedToHDKey(seed);

        for (var i = page * limit; i < page * limit + limit; i++) {
          var address = Mnemonic.hdkeyToAddress(hdk, path, i);
          if (!address) return callback('Cannot derive account from mnemonic', null);
          list.push(address);
        }

        return callback(null, list);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setAccountByKeystore", function (input, password, callback) {
      Keystore.recover(input, password, function (account) {
        if (!account) return callback('Cannot decrypt keystore', null);

        _this.setWallet(account, callback);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getAccountByKeystore", function (input, password, callback) {
      Keystore.recover(input, password, function (account) {
        if (!account) return callback('Cannot decrypt keystore', null);
        return callback(null, account.address);
      });
    });

    var getPassphrase = options.getPassphrase,
        getApproval = options.getApproval;
    if (!getPassphrase || !getApproval) throw new Error('Invalid options');
    _this.getPassphrase = getPassphrase;
    _this.getApproval = getApproval;
    return _this;
  }
  /**
   * @func setWallet
   * Set up acc to storage that can be used as a wallet
   * @param {*} accOpts 
   */


  return Isoxys;
}(WalletInterface);

module.exports = Isoxys;